// file viewers
export const ViewerPrefix = 'viewer'; // shared components
export const ModelViewerPrefix = 'model_viewer';
export const DxfViewerPrefix = 'dxf_viewer';
